import { map } from 'rxjs/operators';
import webApi from '../../../Lib/WebApi';
import { callApi } from '../../Helpers/rxjsHelpers';

export const callApiGetEnvironmentData = () => {
  return callApi(webApi.env.get()).pipe(map((response) => response.Body));
};
